import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _c34c169c = () => interopDefault(import('../pages/account-management/index.vue' /* webpackChunkName: "pages/account-management/index" */))
const _e235b990 = () => interopDefault(import('../pages/direct/index.vue' /* webpackChunkName: "pages/direct/index" */))
const _828fe99a = () => interopDefault(import('../pages/discover-search/index.vue' /* webpackChunkName: "pages/discover-search/index" */))
const _00a251c5 = () => interopDefault(import('../pages/foryou/index.vue' /* webpackChunkName: "pages/foryou/index" */))
const _0fdded24 = () => interopDefault(import('../pages/message/index.vue' /* webpackChunkName: "pages/message/index" */))
const _b78fbad6 = () => interopDefault(import('../pages/node-service-stability/index.vue' /* webpackChunkName: "pages/node-service-stability/index" */))
const _3e7b02ab = () => interopDefault(import('../pages/old-foryou/index.vue' /* webpackChunkName: "pages/old-foryou/index" */))
const _19567090 = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _34af4374 = () => interopDefault(import('../pages/pwa-share-new/index.vue' /* webpackChunkName: "pages/pwa-share-new/index" */))
const _06278594 = () => interopDefault(import('../pages/discover/discoverContent.vue' /* webpackChunkName: "pages/discover/discoverContent" */))
const _497d0910 = () => interopDefault(import('../pages/discover/discoverUtil.ts' /* webpackChunkName: "pages/discover/discoverUtil" */))
const _1d16ac8f = () => interopDefault(import('../pages/pwa-share-new/type.ts' /* webpackChunkName: "pages/pwa-share-new/type" */))
const _4ca00d00 = () => interopDefault(import('../pages/pwa-share-new/utils.ts' /* webpackChunkName: "pages/pwa-share-new/utils" */))
const _dfbf23d8 = () => interopDefault(import('../pages/article/components/article-action/index.vue' /* webpackChunkName: "pages/article/components/article-action/index" */))
const _1c81626f = () => interopDefault(import('../pages/article/components/article-detail/index.vue' /* webpackChunkName: "pages/article/components/article-detail/index" */))
const _544cfedc = () => interopDefault(import('../pages/article/models/main.ts' /* webpackChunkName: "pages/article/models/main" */))
const _7fde13f5 = () => interopDefault(import('../pages/discover/components/app-whatsapp-status/index.vue' /* webpackChunkName: "pages/discover/components/app-whatsapp-status/index" */))
const _c95703c8 = () => interopDefault(import('../pages/discover/components/caption-item/index.vue' /* webpackChunkName: "pages/discover/components/caption-item/index" */))
const _7d403a38 = () => interopDefault(import('../pages/discover/components/expand-words/index.vue' /* webpackChunkName: "pages/discover/components/expand-words/index" */))
const _e825e3c0 = () => interopDefault(import('../pages/discover/components/list/index.vue' /* webpackChunkName: "pages/discover/components/list/index" */))
const _29cbe6e2 = () => interopDefault(import('../pages/discover/components/picture-action-item/index.vue' /* webpackChunkName: "pages/discover/components/picture-action-item/index" */))
const _75710fc1 = () => interopDefault(import('../pages/discover/components/picture-card/index.vue' /* webpackChunkName: "pages/discover/components/picture-card/index" */))
const _6e5340a2 = () => interopDefault(import('../pages/discover/components/top-bar/index.vue' /* webpackChunkName: "pages/discover/components/top-bar/index" */))
const _086bf392 = () => interopDefault(import('../pages/discover/components/user-info-item/index.vue' /* webpackChunkName: "pages/discover/components/user-info-item/index" */))
const _1c895ae8 = () => interopDefault(import('../pages/discover/components/video-action-item/index.vue' /* webpackChunkName: "pages/discover/components/video-action-item/index" */))
const _5a1c4738 = () => interopDefault(import('../pages/discover/components/video-card/index.vue' /* webpackChunkName: "pages/discover/components/video-card/index" */))
const _0c741c10 = () => interopDefault(import('../pages/picture/scripts/app.ts' /* webpackChunkName: "pages/picture/scripts/app" */))
const _17e1b63c = () => interopDefault(import('../pages/picture/scripts/seo.ts' /* webpackChunkName: "pages/picture/scripts/seo" */))
const _38ae0a8a = () => interopDefault(import('../pages/playlist/components/card/index.vue' /* webpackChunkName: "pages/playlist/components/card/index" */))
const _c2ebd26e = () => interopDefault(import('../pages/playlist/components/list/index.vue' /* webpackChunkName: "pages/playlist/components/list/index" */))
const _8e8700a0 = () => interopDefault(import('../pages/playlist/hooks/useList.ts' /* webpackChunkName: "pages/playlist/hooks/useList" */))
const _28e3a84c = () => interopDefault(import('../pages/pwa-share-new/components/action-bar/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/action-bar/index" */))
const _2c4376a5 = () => interopDefault(import('../pages/pwa-share-new/components/comment/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/comment/index" */))
const _3e67011a = () => interopDefault(import('../pages/pwa-share-new/components/feed-list/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/feed-list/index" */))
const _57f24bbd = () => interopDefault(import('../pages/pwa-share-new/components/google-ad/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/google-ad/index" */))
const _339816b7 = () => interopDefault(import('../pages/pwa-share-new/components/loading-dark/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/loading-dark/index" */))
const _45c12efe = () => interopDefault(import('../pages/pwa-share-new/components/lumina-ad/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/lumina-ad/index" */))
const _1765c5c0 = () => interopDefault(import('../pages/pwa-share-new/components/slider-guide/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/slider-guide/index" */))
const _59134930 = () => interopDefault(import('../pages/pwa-share-new/components/slider-guide2/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/slider-guide2/index" */))
const _26f3fa24 = () => interopDefault(import('../pages/pwa-share-new/components/topbar/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/topbar/index" */))
const _2496a610 = () => interopDefault(import('../pages/pwa-share-new/components/video-info/index.vue' /* webpackChunkName: "pages/pwa-share-new/components/video-info/index" */))
const _202c5c74 = () => interopDefault(import('../pages/topic/components/load/index.vue' /* webpackChunkName: "pages/topic/components/load/index" */))
const _3acc3b1f = () => interopDefault(import('../pages/topic/components/picture-card/index.vue' /* webpackChunkName: "pages/topic/components/picture-card/index" */))
const _026fbe0f = () => interopDefault(import('../pages/topic/components/tyml-card/index.vue' /* webpackChunkName: "pages/topic/components/tyml-card/index" */))
const _c149743e = () => interopDefault(import('../pages/topic/components/utils.ts' /* webpackChunkName: "pages/topic/components/utils" */))
const _013c4742 = () => interopDefault(import('../pages/topic/components/video-card/index.vue' /* webpackChunkName: "pages/topic/components/video-card/index" */))
const _f018445e = () => interopDefault(import('../pages/topic/components/water-fall/index.vue' /* webpackChunkName: "pages/topic/components/water-fall/index" */))
const _915aed32 = () => interopDefault(import('../pages/user/components/collection-swipper/index.vue' /* webpackChunkName: "pages/user/components/collection-swipper/index" */))
const _11f9e582 = () => interopDefault(import('../pages/user/components/list/index.vue' /* webpackChunkName: "pages/user/components/list/index" */))
const _1fbab815 = () => interopDefault(import('../pages/user/components/nav/index.vue' /* webpackChunkName: "pages/user/components/nav/index" */))
const _39cc394f = () => interopDefault(import('../pages/user/components/post-card/index.vue' /* webpackChunkName: "pages/user/components/post-card/index" */))
const _217aa2a8 = () => interopDefault(import('../pages/user/components/user-profile-base-info/index.vue' /* webpackChunkName: "pages/user/components/user-profile-base-info/index" */))
const _8990c272 = () => interopDefault(import('../pages/user/hooks/useInfo.ts' /* webpackChunkName: "pages/user/hooks/useInfo" */))
const _521b8cd7 = () => interopDefault(import('../pages/user/hooks/useList.ts' /* webpackChunkName: "pages/user/hooks/useList" */))
const _2452141e = () => interopDefault(import('../pages/user/hooks/useNoticePopup.ts' /* webpackChunkName: "pages/user/hooks/useNoticePopup" */))
const _3a307e55 = () => interopDefault(import('../pages/discover/components/video-action-item/template.config.ts' /* webpackChunkName: "pages/discover/components/video-action-item/template.config" */))
const _dc4713a0 = () => interopDefault(import('../pages/pwa-share-new/components/video-info/unmuted.vue' /* webpackChunkName: "pages/pwa-share-new/components/video-info/unmuted" */))
const _2149b97b = () => interopDefault(import('../pages/user/components/user-profile-base-info/useProfileInfo.ts' /* webpackChunkName: "pages/user/components/user-profile-base-info/useProfileInfo" */))
const _174203e1 = () => interopDefault(import('../pages/discover/components/caption-item/scripts/app.ts' /* webpackChunkName: "pages/discover/components/caption-item/scripts/app" */))
const _355dc825 = () => interopDefault(import('../pages/discover/components/caption-item/scripts/seo.ts' /* webpackChunkName: "pages/discover/components/caption-item/scripts/seo" */))
const _21faf564 = () => interopDefault(import('../pages/discover/components/picture-action-item/scripts/app.ts' /* webpackChunkName: "pages/discover/components/picture-action-item/scripts/app" */))
const _63851e40 = () => interopDefault(import('../pages/discover/components/picture-action-item/scripts/common.ts' /* webpackChunkName: "pages/discover/components/picture-action-item/scripts/common" */))
const _0d1e4992 = () => interopDefault(import('../pages/discover/components/picture-action-item/scripts/seo.ts' /* webpackChunkName: "pages/discover/components/picture-action-item/scripts/seo" */))
const _531e7571 = () => interopDefault(import('../pages/discover/components/video-action-item/scripts/app.ts' /* webpackChunkName: "pages/discover/components/video-action-item/scripts/app" */))
const _32b3173d = () => interopDefault(import('../pages/discover/components/video-action-item/scripts/common.ts' /* webpackChunkName: "pages/discover/components/video-action-item/scripts/common" */))
const _713a39b5 = () => interopDefault(import('../pages/discover/components/video-action-item/scripts/seo.ts' /* webpackChunkName: "pages/discover/components/video-action-item/scripts/seo" */))
const _aef4909e = () => interopDefault(import('../pages/pwa-share-new/components/action-bar/scripts/app.ts' /* webpackChunkName: "pages/pwa-share-new/components/action-bar/scripts/app" */))
const _a3eca606 = () => interopDefault(import('../pages/pwa-share-new/components/action-bar/scripts/common.ts' /* webpackChunkName: "pages/pwa-share-new/components/action-bar/scripts/common" */))
const _72bd0816 = () => interopDefault(import('../pages/pwa-share-new/components/action-bar/scripts/seo.ts' /* webpackChunkName: "pages/pwa-share-new/components/action-bar/scripts/seo" */))
const _31f6dabf = () => interopDefault(import('../pages/article/_content.vue' /* webpackChunkName: "pages/article/_content" */))
const _35d2d644 = () => interopDefault(import('../pages/discover/_content.vue' /* webpackChunkName: "pages/discover/_content" */))
const _31508c2b = () => interopDefault(import('../pages/picture/_photoId.vue' /* webpackChunkName: "pages/picture/_photoId" */))
const _0efb41ec = () => interopDefault(import('../pages/playlist/_albumId.vue' /* webpackChunkName: "pages/playlist/_albumId" */))
const _3b398c26 = () => interopDefault(import('../pages/topic/_content.vue' /* webpackChunkName: "pages/topic/_content" */))
const _e5817aa6 = () => interopDefault(import('../pages/user/_userId.vue' /* webpackChunkName: "pages/user/_userId" */))
const _79471664 = () => interopDefault(import('../pages/video/_photoId.vue' /* webpackChunkName: "pages/video/_photoId" */))
const _5b2f2d76 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account-management",
    component: _c34c169c,
    name: "account-management"
  }, {
    path: "/direct",
    component: _e235b990,
    name: "direct"
  }, {
    path: "/discover-search",
    component: _828fe99a,
    name: "discover-search"
  }, {
    path: "/foryou",
    component: _00a251c5,
    name: "foryou"
  }, {
    path: "/message",
    component: _0fdded24,
    name: "message"
  }, {
    path: "/node-service-stability",
    component: _b78fbad6,
    name: "node-service-stability"
  }, {
    path: "/old-foryou",
    component: _3e7b02ab,
    name: "old-foryou"
  }, {
    path: "/profile",
    component: _19567090,
    name: "profile"
  }, {
    path: "/pwa-share-new",
    component: _34af4374,
    name: "pwa-share-new"
  }, {
    path: "/discover/discoverContent",
    component: _06278594,
    name: "discover-discoverContent"
  }, {
    path: "/discover/discoverUtil",
    component: _497d0910,
    name: "discover-discoverUtil"
  }, {
    path: "/pwa-share-new/type",
    component: _1d16ac8f,
    name: "pwa-share-new-type"
  }, {
    path: "/pwa-share-new/utils",
    component: _4ca00d00,
    name: "pwa-share-new-utils"
  }, {
    path: "/article/components/article-action",
    component: _dfbf23d8,
    name: "article-components-article-action"
  }, {
    path: "/article/components/article-detail",
    component: _1c81626f,
    name: "article-components-article-detail"
  }, {
    path: "/article/models/main",
    component: _544cfedc,
    name: "article-models-main"
  }, {
    path: "/discover/components/app-whatsapp-status",
    component: _7fde13f5,
    name: "discover-components-app-whatsapp-status"
  }, {
    path: "/discover/components/caption-item",
    component: _c95703c8,
    name: "discover-components-caption-item"
  }, {
    path: "/discover/components/expand-words",
    component: _7d403a38,
    name: "discover-components-expand-words"
  }, {
    path: "/discover/components/list",
    component: _e825e3c0,
    name: "discover-components-list"
  }, {
    path: "/discover/components/picture-action-item",
    component: _29cbe6e2,
    name: "discover-components-picture-action-item"
  }, {
    path: "/discover/components/picture-card",
    component: _75710fc1,
    name: "discover-components-picture-card"
  }, {
    path: "/discover/components/top-bar",
    component: _6e5340a2,
    name: "discover-components-top-bar"
  }, {
    path: "/discover/components/user-info-item",
    component: _086bf392,
    name: "discover-components-user-info-item"
  }, {
    path: "/discover/components/video-action-item",
    component: _1c895ae8,
    name: "discover-components-video-action-item"
  }, {
    path: "/discover/components/video-card",
    component: _5a1c4738,
    name: "discover-components-video-card"
  }, {
    path: "/picture/scripts/app",
    component: _0c741c10,
    name: "picture-scripts-app"
  }, {
    path: "/picture/scripts/seo",
    component: _17e1b63c,
    name: "picture-scripts-seo"
  }, {
    path: "/playlist/components/card",
    component: _38ae0a8a,
    name: "playlist-components-card"
  }, {
    path: "/playlist/components/list",
    component: _c2ebd26e,
    name: "playlist-components-list"
  }, {
    path: "/playlist/hooks/useList",
    component: _8e8700a0,
    name: "playlist-hooks-useList"
  }, {
    path: "/pwa-share-new/components/action-bar",
    component: _28e3a84c,
    name: "pwa-share-new-components-action-bar"
  }, {
    path: "/pwa-share-new/components/comment",
    component: _2c4376a5,
    name: "pwa-share-new-components-comment"
  }, {
    path: "/pwa-share-new/components/feed-list",
    component: _3e67011a,
    name: "pwa-share-new-components-feed-list"
  }, {
    path: "/pwa-share-new/components/google-ad",
    component: _57f24bbd,
    name: "pwa-share-new-components-google-ad"
  }, {
    path: "/pwa-share-new/components/loading-dark",
    component: _339816b7,
    name: "pwa-share-new-components-loading-dark"
  }, {
    path: "/pwa-share-new/components/lumina-ad",
    component: _45c12efe,
    name: "pwa-share-new-components-lumina-ad"
  }, {
    path: "/pwa-share-new/components/slider-guide",
    component: _1765c5c0,
    name: "pwa-share-new-components-slider-guide"
  }, {
    path: "/pwa-share-new/components/slider-guide2",
    component: _59134930,
    name: "pwa-share-new-components-slider-guide2"
  }, {
    path: "/pwa-share-new/components/topbar",
    component: _26f3fa24,
    name: "pwa-share-new-components-topbar"
  }, {
    path: "/pwa-share-new/components/video-info",
    component: _2496a610,
    name: "pwa-share-new-components-video-info"
  }, {
    path: "/topic/components/load",
    component: _202c5c74,
    name: "topic-components-load"
  }, {
    path: "/topic/components/picture-card",
    component: _3acc3b1f,
    name: "topic-components-picture-card"
  }, {
    path: "/topic/components/tyml-card",
    component: _026fbe0f,
    name: "topic-components-tyml-card"
  }, {
    path: "/topic/components/utils",
    component: _c149743e,
    name: "topic-components-utils"
  }, {
    path: "/topic/components/video-card",
    component: _013c4742,
    name: "topic-components-video-card"
  }, {
    path: "/topic/components/water-fall",
    component: _f018445e,
    name: "topic-components-water-fall"
  }, {
    path: "/user/components/collection-swipper",
    component: _915aed32,
    name: "user-components-collection-swipper"
  }, {
    path: "/user/components/list",
    component: _11f9e582,
    name: "user-components-list"
  }, {
    path: "/user/components/nav",
    component: _1fbab815,
    name: "user-components-nav"
  }, {
    path: "/user/components/post-card",
    component: _39cc394f,
    name: "user-components-post-card"
  }, {
    path: "/user/components/user-profile-base-info",
    component: _217aa2a8,
    name: "user-components-user-profile-base-info"
  }, {
    path: "/user/hooks/useInfo",
    component: _8990c272,
    name: "user-hooks-useInfo"
  }, {
    path: "/user/hooks/useList",
    component: _521b8cd7,
    name: "user-hooks-useList"
  }, {
    path: "/user/hooks/useNoticePopup",
    component: _2452141e,
    name: "user-hooks-useNoticePopup"
  }, {
    path: "/discover/components/video-action-item/template.config",
    component: _3a307e55,
    name: "discover-components-video-action-item-template.config"
  }, {
    path: "/pwa-share-new/components/video-info/unmuted",
    component: _dc4713a0,
    name: "pwa-share-new-components-video-info-unmuted"
  }, {
    path: "/user/components/user-profile-base-info/useProfileInfo",
    component: _2149b97b,
    name: "user-components-user-profile-base-info-useProfileInfo"
  }, {
    path: "/discover/components/caption-item/scripts/app",
    component: _174203e1,
    name: "discover-components-caption-item-scripts-app"
  }, {
    path: "/discover/components/caption-item/scripts/seo",
    component: _355dc825,
    name: "discover-components-caption-item-scripts-seo"
  }, {
    path: "/discover/components/picture-action-item/scripts/app",
    component: _21faf564,
    name: "discover-components-picture-action-item-scripts-app"
  }, {
    path: "/discover/components/picture-action-item/scripts/common",
    component: _63851e40,
    name: "discover-components-picture-action-item-scripts-common"
  }, {
    path: "/discover/components/picture-action-item/scripts/seo",
    component: _0d1e4992,
    name: "discover-components-picture-action-item-scripts-seo"
  }, {
    path: "/discover/components/video-action-item/scripts/app",
    component: _531e7571,
    name: "discover-components-video-action-item-scripts-app"
  }, {
    path: "/discover/components/video-action-item/scripts/common",
    component: _32b3173d,
    name: "discover-components-video-action-item-scripts-common"
  }, {
    path: "/discover/components/video-action-item/scripts/seo",
    component: _713a39b5,
    name: "discover-components-video-action-item-scripts-seo"
  }, {
    path: "/pwa-share-new/components/action-bar/scripts/app",
    component: _aef4909e,
    name: "pwa-share-new-components-action-bar-scripts-app"
  }, {
    path: "/pwa-share-new/components/action-bar/scripts/common",
    component: _a3eca606,
    name: "pwa-share-new-components-action-bar-scripts-common"
  }, {
    path: "/pwa-share-new/components/action-bar/scripts/seo",
    component: _72bd0816,
    name: "pwa-share-new-components-action-bar-scripts-seo"
  }, {
    path: "/article/:content?",
    component: _31f6dabf,
    name: "article-content"
  }, {
    path: "/discover/:content?",
    component: _35d2d644,
    name: "discover-content"
  }, {
    path: "/picture/:photoId?",
    component: _31508c2b,
    name: "picture-photoId"
  }, {
    path: "/playlist/:albumId?",
    component: _0efb41ec,
    name: "playlist-albumId"
  }, {
    path: "/topic/:content?",
    component: _3b398c26,
    name: "topic-content"
  }, {
    path: "/user/:userId?",
    component: _e5817aa6,
    name: "user-userId"
  }, {
    path: "/video/:photoId?",
    component: _79471664,
    name: "video-photoId"
  }, {
    path: "/",
    component: _5b2f2d76,
    name: "index"
  }, {
    path: "/@*/playlist/:albumId",
    component: _0efb41ec,
    name: "playlist-detail"
  }, {
    path: "/@*/video/:photoId",
    component: _79471664,
    meta: {"replacePhotoId":true},
    name: "video-detail"
  }, {
    path: "/@*/picture/:photoId",
    component: _31508c2b,
    name: "picture-detail"
  }, {
    path: "/@*",
    component: _e5817aa6,
    name: "profile"
  }, {
    path: "/pwa-share-new/:photoId",
    component: _34af4374,
    name: "video-detail-share"
  }, {
    path: "/search/:regex(.+)/video/:photoId",
    component: _828fe99a,
    meta: {"replacePhotoId":true},
    name: "discover-search"
  }, {
    path: "/search/video/:photoId",
    component: _828fe99a,
    meta: {"replacePhotoId":true},
    name: "discover-search"
  }, {
    path: "/node-service-stability/timeout",
    component: _b78fbad6,
    name: "node-service-stability-timeout"
  }, {
    path: "/node-service-stability/fallback",
    component: _b78fbad6,
    name: "node-service-stability-fallback"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
